// extracted by mini-css-extract-plugin
export var container = "index-module--container--2-v0c";
export var grid = "index-module--grid--3uijn";
export var card = "index-module--card--2cdvd";
export var intro = "index-module--intro--joOMj";